// extracted by mini-css-extract-plugin
export var ssoDraftDetails = "sso-draft-details_aQeifyYT1aPaUiNn6WvS";
export var ssoDraftDetailsColumns = "sso-draft-details__columns_N57PhK2QkXRl2t9ez24G";
export var ssoDraftDetailsRow = "sso-draft-details__row_uodR8ysSUdo6bvqrz5Jk";